import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { MainApp } from './components/MainApp';
import { ArchitectureDiagram } from './components/ArchitectureDiagram';
import { ProjectStructure } from './components/ProjectStructure';
import { LinkSharing } from './components/LinkSharing';
import { EmailManager } from './components/EmailManager';
import { EmailManagerV2 } from './components/EmailManagerV2';
import ApiDebugCrud from './components/ApiDebugCrud';

function App() {
  return (
    <Routes>
      <Route path="/" element={<EmailManagerV2 />} />
      <Route path="/v1" element={<EmailManager />} />
      <Route path="/debug" element={<ApiDebugCrud />} />
      <Route path="/main" element={<MainApp />} />
      <Route path="/links" element={<LinkSharing />} />
      <Route path="/architecture" element={<ArchitectureDiagram />} />
      <Route path="/structure" element={<ProjectStructure />} />
    </Routes>
  );
}

export default App;
